import * as types from 'constants/ActionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Array<string>} State */

/** @type {State} */
const initialState = [];

/**
 * @param {State} _
 * @param {import('modules/dealers/types').FetchDealersSuccessAction} action
 * @returns {State}
 */
const updateState = (_, { payload }) => payload.content.map(dealer => dealer.id);

/**
 * @returns State
 */
const resetState = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_DEALERS_FAILURE]: resetState,
  [types.FETCH_DEALERS_SUCCESS]: updateState,
});
